import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
  Select,
  Paper,
  Autocomplete,
  Drawer,
  IconButton,
  FormHelperText,
  Tooltip,
  CircularProgress,
  Fade,
  Dialog,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import AppointmentList from "./AppointmentList";
import { BASE_URL } from "../../constants";
import DeleteIcon from "@mui/icons-material/Delete";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import { FILE_RULES, validateFile } from "../../utils/fileValidation";
import { useLocation, useNavigate } from "react-router-dom";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import TransgenderIcon from "@mui/icons-material/Transgender";
import { toast } from "react-toastify";
const INITIAL_STATE = {
  name: "",
  qualifications: [""],
  regId: "",
  note: "",
  consultFees: "",
  isConsultant: false,
  isSignatory: false,
  signatoryCat: "",
  signFile: null,
  signHeader: "",
};
const INITIAL_STATE_P = {
  name: "",
  dob: "",
  age: "",
  gender: "",
  mobile: "",
  address: "",
  aadhar: "",
};
const INITIAL_STATE_C = {
  centreName: "",
  centreAddress: "",
  centreContactPerson: "",
  centreContactNumber: "",
};
const DoctorConsult = () => {
  const [formData, setFormData] = useState({
    doctorId: null,
    patientId: null,
    centreId: null,
    date: null,
    time: null,
    note: "",
  });
  const user = useRecoilValue(authState);
  const location = useLocation();
  const navigate = useNavigate();
  const refData = location?.state || null;
  const [doctors, setDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  // const [centers, setCenters] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false); // To control form visibility
  const [appointments, setAppointments] = useState([]);
  const [patientSearchInput, setPatientSearchInput] = useState("");
  const [doctorSearchInput, setDoctorSearchInput] = useState("");
  const [centerSearchInput, setCenterSearchInput] = useState("");
  const [errors, setErrors] = useState({});
  // const [filteredDoctor, setFilteredDoctor] = useState([]);

  const [doctorData, setDoctorData] = useState(INITIAL_STATE);
  const [centerData, setCenterData] = useState("");
  const [patientData, setPatientData] = useState(INITIAL_STATE_P);
  const [errorsPatient, setErrorsPatient] = useState({});
  const [centers, setCenters] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [patientForm, setPatientForm] = useState(false);
  const [doctorForm, setDoctorForm] = useState(false);
  const [centerForm, setCenterForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (refData && refData?.fromCentreRef) {
      setFormData({
        doctorId: refData?.doctor,
        patientId: refData?.patient,
        centreId: refData?.centre,
      });
    }
  }, [refData]);
  useEffect(() => {
    const fetchAllPatient = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}api/user/common/get-all-patient`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        const patients = await response.json();
        setPatients(patients.data);
      } catch (error) {
        alert("Something went wrong! Please try again.");
      }
    };
    fetchAllPatient();

    const fetchAllDoctors = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}api/user/common/get-all-doctor-non-limit`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        const resp = await response.json();
        setDoctors(resp.data);
      } catch (error) {
        alert("Something went wrong! Please try again.");
      }
    };
    fetchAllDoctors();

    const fetchAllCenters = async () => {
      try {
        const response = await fetch(`${BASE_URL}api/user/common/get-centers`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const centers = await response.json();
        setCenters(centers.data);
      } catch (error) {
        alert("Something went wrong! Please try again.");
      }
    };
    fetchAllCenters();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (newValue) => {
    setFormData((prevState) => ({
      ...prevState,
      date: newValue,
    }));
  };

  const handleTimeChange = (newValue) => {
    setFormData((prevState) => ({
      ...prevState,
      time: newValue,
    }));
  };

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingSubmit(true);
    if (!formData.date) {
      toast.error("Please select Appointment Date");
      setLoadingSubmit(false);
      return;
    }
    if (!formData.patientId) {
      toast.error("Please select a patient");
      setLoadingSubmit(false);
      return;
    }
    if (!formData.doctorId) {
      toast.error("Please select a doctor");
      setLoadingSubmit(false);
      return;
    }
    if (!formData.centreId) {
      toast.error("Please select a centre");
      setLoadingSubmit(false);
      return;
    }

    const formattedData = {
      ...formData,
      status: "booked",
      appointmentStatus: "booked",
      patientId: formData.patientId,
      doctorId: formData.doctorId,
      centreId: formData.centreId,
      date: dayjs(formData.date).format("MMMM DD, YYYY"), // Formats date as "January 01, 2025"
      // time: dayjs(formData.time).format("hh:mm A"), // Keeps time as "hh:mm AM/PM"
    };

    try {
      const response = await fetch(
        `${BASE_URL}api/user/opd/create-appointment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formattedData),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert(
          `Appointment created successfully! Appointment ID: ${result.data.appointmentId}`,
        );
        // setFormData({
        //   doctorId: null,
        //   patientId: null,
        //   date: null,
        //   // time: null,
        //   discountAmount: 0,
        //   isFeesCollected: false,
        //   note: "",
        // });
        window.location.reload();
        // setAppointments((prevAppointments) => [
        //   result.data,
        //   ...prevAppointments,
        // ]);
        // navigate(location.pathname, { replace: true, state: null });
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      alert("Network error. Please try again later.");
    } finally {
      setLoadingSubmit(false);
    }
  };

  useEffect(() => {
    if (formData.doctorId && formData.patientId && formData.centreId) {
      setIsFormVisible(true); // Show the rest of the form when both are selected
    } else {
      setIsFormVisible(false); // Hide the rest of the form
    }
  }, [formData.doctorId, formData.patientId, formData.centreId]);

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setDoctorSearchInput("");
  };

  const handleNewChange = (e) => {
    setDoctorData({
      ...doctorData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSignFileChange = async (e) => {
    const file = e.target.files[0];
    const result = await validateFile(file, FILE_RULES.signature);
    if (!result.valid) {
      alert(result.error);
      e.target.value = "";
      return;
    }
    setDoctorData({
      ...doctorData,
      signFile: file,
    });
  };

  const handleQualificationChange = (index, value) => {
    const updatedQualifications = [...doctorData.qualifications];
    updatedQualifications[index] = value;
    setDoctorData({ ...doctorData, qualifications: updatedQualifications });
  };

  const addQualification = () => {
    setDoctorData({
      ...doctorData,
      qualifications: [...doctorData.qualifications, ""],
    });
  };

  const removeQualification = (index) => {
    const updatedQualifications = doctorData.qualifications.filter(
      (_, i) => i !== index,
    );
    setDoctorData({ ...doctorData, qualifications: updatedQualifications });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!doctorData.name) {
      newErrors.name = "Doctor name is required.";
    }
    if (!doctorData.qualifications.some((q) => q.trim())) {
      newErrors.qualifications = "At least one qualification is required.";
    }
    if (!doctorData.regId) {
      newErrors.regId = "Registration ID is required.";
    }
    // if (!doctorData.note) {
    //   newErrors.note = "OPD hours are required.";
    // }
    if (!doctorData.consultFees) {
      newErrors.consultFees = "Consultation fees are required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //patient form

  const handleChangePatient = (e) => {
    if (e.target.name === "age") {
      if (patientData.dob === "") {
        return setPatientData({
          ...patientData,
          [e.target.name]: e.target.value,
        });
      } else {
        return setPatientData({ ...patientData, age: e.target.value, dob: "" });
      }
    }
    setPatientData({
      ...patientData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeCenter = (e) => {
    return setCenterData({
      ...centerData,
      [e.target.name]: e.target.value,
    });
  };
  const handleDateChangePatient = (newValue) => {
    const formattedDate = dayjs(newValue).format("DD-MM-YY"); // Display in "DD-MM-YY" format
    if (patientData.age === "") {
      return setPatientData({ ...patientData, dob: formattedDate });
    } else {
      return setPatientData({ ...patientData, dob: formattedDate, age: "" });
    }
  };
  const calculateAge = (dob) => {
    const birthDate = dayjs(dob, "DD-MM-YY");
    const now = dayjs();
    const years = now.diff(birthDate, "year");
    const months = now.diff(birthDate.add(years, "year"), "month");
    const days = now.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };
  const handleGenderChange = (e) => {
    const { value } = e.target;
    setPatientData({ ...patientData, gender: value });
  };
  const validateFormPatient = () => {
    const newErrors = {};

    if (!patientData.name) {
      newErrors.name = "Patient name is required.";
    }
    if (!patientData.dob && !patientData.age) {
      newErrors.dob = "required.";
      newErrors.age = "required.";
    }
    if (!patientData.gender) {
      newErrors.gender = "Patient gender is required.";
    }
    // if (!patientData.address) {
    //   newErrors.address = "Patient Address is required.";
    // }
    // if (!/^[6-9]\d{9}$/.test(patientData.mobile)) {
    //   newErrors.mobile = "Invalid 10-digit contact number.";
    // }
    // if (
    //   patientData.aadhar &&
    //   /^\d{4}\s?\d{4}\s?\d{4}$/.test(patientData.aadhar)
    // ) {
    //   newErrors.aadhar = "Invalid Aadhar number.";
    // }
    setErrorsPatient(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [patientSuggestions, setPatientSuggestions] = useState([]);
  const [loadingPatients, setLoadingPatients] = useState(false);
  const [doctorSuggestions, setDoctorSuggestions] = useState([]);
  const [loadingDoctors, setLoadingDoctors] = useState(false);
  const [centerSuggestions, setCenterSuggestions] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);

  useEffect(() => {
    setLoadingPatients(false);
    if (patientSearchInput.trim()) {
      setLoadingPatients(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/common/patients/search?query=${patientSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const patients = await res.json();
          setPatientSuggestions(patients.data);
        } catch (err) {
          setPatientSuggestions([]);
        } finally {
          setLoadingPatients(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setPatientSuggestions([]);
    }
  }, [patientSearchInput]);

  useEffect(() => {
    setLoadingDoctors(false);
    if (doctorSearchInput.trim()) {
      setLoadingDoctors(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/opd/doctors?query=${doctorSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const doctors = await res.json();
          setDoctorSuggestions(doctors.data);
        } catch (err) {
          setDoctorSuggestions([]);
        } finally {
          setLoadingDoctors(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setDoctorSuggestions([]);
    }
  }, [doctorSearchInput]);

  useEffect(() => {
    setLoadingCenters(false);
    if (centerSearchInput.trim()) {
      setLoadingCenters(true);
      const delayDebounce = setTimeout(async () => {
        try {
          const res = await fetch(
            `${BASE_URL}api/user/common/centers/search?query=${centerSearchInput}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const centers = await res.json();
          setCenterSuggestions(centers.data);
        } catch (err) {
          setCenterSuggestions([]);
        } finally {
          setLoadingCenters(false);
        }
      }, 500); // debounce

      return () => clearTimeout(delayDebounce);
    } else {
      setPatientSuggestions([]);
    }
  }, [centerSearchInput]);

  const handleSelectPatient = async (event, newValue) => {
    if (newValue) {
      setFormData({ ...formData, patientId: newValue._id });
    } else {
      setFormData((prev) => ({
        ...prev,
        patientId: null,
      }));
    }
  };

  // const handleSelectCenter = async (event, newValue) => {
  //   if (newValue?._id) {
  //     setFormData({ ...formData, centreId: newValue._id });
  //   }
  // };
  const handleSelectCenter = (event, newValue) => {
    if (newValue?._id) {
      setFormData((prev) => ({
        ...prev,
        centreId: newValue._id,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        centreId: null,
      }));
    }
  };

  const getGenderIcon = (gender) => {
    const g = gender.toLowerCase();
    switch (g) {
      case "male":
        return <MaleIcon sx={{ color: "#2563eb" }} />;
      case "female":
        return <FemaleIcon sx={{ color: "#db2777" }} />;
      case "others":
        return <TransgenderIcon sx={{ color: "#7c3aed" }} />;
      default:
        return "";
    }
  };

  const showAge = (dob) => {
    const birthDate = dayjs(dob, "MMMM DD, YYYY");
    const today = dayjs();

    const years = today.diff(birthDate, "year");
    const months = today.diff(birthDate.add(years, "year"), "month");
    const days = today.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  const handleSelectDoctor = async (event, newValue) => {
    if (newValue?._id) {
      setFormData({ ...formData, doctorId: newValue._id });
    } else {
      setFormData((prev) => ({
        ...prev,
        doctorId: null,
      }));
    }
  };

  const [patientLoading, setPatientLoading] = useState(false);
  const [doctorLoading, setDoctorLoading] = useState(false);
  const [centerLoading, setCenterLoading] = useState(false);

  const handleSubmitPatient = async (e) => {
    e.preventDefault();
    if (validateFormPatient()) {
      setPatientLoading(true);
      let data = patientData;

      // Convert "DD-MM-YY" to "MMMM DD, YYYY"
      if (patientData.dob) {
        const formattedDob = dayjs(patientData.dob, "DD-MM-YY").format(
          "MMMM DD, YYYY",
        );
        data = { ...data, dob: formattedDob };
      }

      if (parseInt(patientData.age) > 0) {
        const currentYear = new Date().getFullYear();
        const yearOfBirth = currentYear - parseInt(patientData.age);
        const dob = new Date(yearOfBirth, 0, 1);
        const formattedDob = `${dob.toLocaleString("en-US", {
          month: "long",
        })} ${dob.getDate().toString().padStart(2, "0")}, ${dob.getFullYear()}`;

        data = {
          ...data,
          dob: formattedDob,
        };
      }
      delete data.age;

      try {
        const response = await fetch(
          `${BASE_URL}api/user/common/patient-register`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          },
        );

        const resp = await response.json();
        console.log("PPPP", resp);
        if (resp.success) {
          alert(resp.message);
          setPatientSearchInput(patientData.name);
          setPatientData(INITIAL_STATE);
          setIsDrawerOpen(false);
          setPatients([...patients, resp.patient]);
          setIsDrawerOpen(false);
          setFormData({ ...formData, patientId: resp.patient._id });
          setPatientForm(false);
        } else {
          alert("Error: " + resp.message);
        }
      } catch (error) {
        alert(
          "Something went wrong! Please try again.12121219090909: " + error,
        );
      } finally {
        setPatientLoading(false);
      }
    }
  };

  console.log("FFFDDDD####", formData);

  const handleDoctorSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setDoctorLoading(true);
      const doctorFormData = new FormData();
      for (const key in doctorData) {
        doctorFormData.append(key, doctorData[key]);
      }
      try {
        const response = await fetch(
          `${BASE_URL}api/user/common/doctor-register`,
          {
            method: "POST",
            headers: {},
            body: doctorFormData, // Send FormData directly
          },
        );

        const resp = await response.json();

        if (resp.success) {
          alert(resp.message);
          setDoctorData(INITIAL_STATE);
          setDoctorSearchInput(doctorData.name);
          setDoctors([...doctors, resp.doctor]);
          setIsDrawerOpen(false);
          setFormData({ ...formData, doctorId: resp.doctor._id });
          setDoctorForm(false);
        } else {
          toast.error(resp.message);
        }
      } catch (error) {
        toast.error("Something went wrong! Please try again.1211212");
      } finally {
        setDoctorLoading(false);
      }
    }
  };

  const handleSubmitCenter = async (e) => {
    e.preventDefault();
    setCenterLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/user/common/create-center`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(centerData),
      });

      const resp = await response.json();
      console.log("CCCCCCCCC-----", resp);
      if (resp.success) {
        alert(resp.message);
        setCenterData(INITIAL_STATE_C);
        setCenterSearchInput(centerData.centreName);
        setCenters([...centers, resp.center]);
        setIsDrawerOpen(false);
        setFormData({ ...formData, centerId: resp.center._id });
        setCenterData(false);
      } else {
        toast.error(resp.message);
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
      setCenterLoading(false);
    }
  };

  return (
    <>
      {user?._doc?.permissions?.opdManagement?.create && (
        // <Paper elevation={3} sx={{ p: 3 }}>
        //   <Box
        //     component="form"
        //     onSubmit={handleSubmit}
        //     sx={{
        //       "& .MuiTextField-root": { mb: 2, width: "100%" },
        //       "& .MuiFormControl-root": { mb: 2, width: "100%" },
        //     }}
        //     noValidate
        //     autoComplete="off"
        //   >
        //     <Grid container spacing={3}>
        //       <Grid item xs={12} sm={4}>
        //         <Autocomplete
        //           options={patientSuggestions}
        //           getOptionLabel={(option) =>
        //             `${option.name} (${option.patientID}) - ${option.mobile}`
        //           }
        //           loading={loadingPatients}
        //           onInputChange={(e, value) => setPatientSearchInput(value)}
        //           onChange={handleSelectPatient}
        //           renderOption={(props, option, { inputValue }) => {
        //             const nameParts = parse(
        //               option.name,
        //               match(option.name, inputValue)
        //             );
        //             const idParts = parse(
        //               option.patientID,
        //               match(option.patientID, inputValue)
        //             );
        //             const mobileParts = parse(
        //               option.mobile,
        //               match(option.mobile, inputValue)
        //             );
        //             const gender = option.gender;
        //             const dob = option.dob;

        //             return (
        //               <Box
        //                 component="li"
        //                 {...props}
        //                 sx={{
        //                   display: "flex",
        //                   flexDirection: "column",
        //                   alignItems: "flex-start",
        //                   justifyContent: "flex-start",
        //                   p: 1.2,
        //                   borderBottom: "1px solid #eee",
        //                   width: "100%",
        //                   "&:hover": { backgroundColor: "#f0f4f8" },
        //                 }}
        //               >
        //                 <Box
        //                   sx={{
        //                     width: "100%",
        //                     display: "flex",
        //                     justifyContent: "space-between",
        //                     alignItems: "center",
        //                   }}
        //                 >
        //                   <Box component="span">
        //                     {nameParts.map((part, index) => (
        //                       <span
        //                         key={index}
        //                         style={{
        //                           fontWeight: part.highlight ? 700 : 400,
        //                           backgroundColor: part.highlight
        //                             ? "#ffe082"
        //                             : "transparent",
        //                           padding: "2px",
        //                           borderRadius: "3px",
        //                           fontSize: "13px",
        //                         }}
        //                       >
        //                         {part.text}
        //                       </span>
        //                     ))}
        //                   </Box>
        //                   <Box
        //                     component="span"
        //                     sx={{
        //                       fontWeight: 400,
        //                       display: "flex",
        //                       alignItems: "center",
        //                       gap: "4px",
        //                       fontSize: "10px",
        //                     }}
        //                   >
        //                     {gender}
        //                     {getGenderIcon(gender)}
        //                   </Box>
        //                 </Box>

        //                 <Typography
        //                   variant="caption"
        //                   color="text.secondary"
        //                   sx={{ width: "100%" }}
        //                 >
        //                   <Box
        //                     sx={{
        //                       display: "flex",
        //                       justifyContent: "space-between",
        //                       width: "100%",
        //                       alignItems: "center",
        //                     }}
        //                   >
        //                     {/* Left side: Age and Phone */}
        //                     <Box component="span">
        //                       <span style={{ fontWeight: 400 }}>
        //                         Age: {showAge(dob)}
        //                       </span>{" "}
        //                       | Ph:{" "}
        //                       {mobileParts.map((part, index) => (
        //                         <span
        //                           key={index}
        //                           style={{
        //                             fontWeight: part.highlight ? 600 : 400,
        //                             backgroundColor: part.highlight
        //                               ? "#ffe082"
        //                               : "transparent",
        //                           }}
        //                         >
        //                           {part.text}
        //                         </span>
        //                       ))}
        //                     </Box>

        //                     {/* Right side: ID */}
        //                     <Box component="span">
        //                       {idParts.map((part, index) => (
        //                         <span
        //                           key={index}
        //                           style={{
        //                             fontSize: "10px",
        //                             fontWeight: part.highlight ? 600 : 400,
        //                             backgroundColor: part.highlight
        //                               ? "#ffe082"
        //                               : "transparent",
        //                           }}
        //                         >
        //                           {part.text}
        //                         </span>
        //                       ))}
        //                     </Box>
        //                   </Box>
        //                 </Typography>
        //               </Box>
        //             );
        //           }}
        //           renderInput={(params) => (
        //             <TextField
        //               {...params}
        //               label="Search Patient"
        //               variant="outlined"
        //               size="small"
        //               sx={{ backgroundColor: "#fff" }}
        //               InputProps={{
        //                 ...params.InputProps,
        //                 endAdornment: (
        //                   <>
        //                     {loadingPatients ? (
        //                       <CircularProgress color="inherit" size={20} />
        //                     ) : null}
        //                     {params.InputProps.endAdornment}
        //                   </>
        //                 ),
        //               }}
        //             />
        //           )}
        //           noOptionsText={
        //             patientSearchInput.trim() ? (
        //               <Box>
        //                 <Typography variant="body2" sx={{ mb: 1 }}>
        //                   No patient found.
        //                 </Typography>
        //                 {user?._doc?.permissions?.patientManagement?.create && (
        //                   <Button
        //                     variant="contained"
        //                     size="small"
        //                     onClick={() => {
        //                       setIsDrawerOpen(true);
        //                       setPatientForm(true);
        //                       setPatientData({
        //                         ...patientData,
        //                         name: patientSearchInput.trim(),
        //                       });
        //                       setDoctorForm(false);
        //                       setCenterForm(false);
        //                     }}
        //                   >
        //                     Register
        //                   </Button>
        //                 )}
        //               </Box>
        //             ) : (
        //               "Search by: Id, Name or Ph.No"
        //             )
        //           }
        //         />
        //       </Grid>
        //       <Grid item xs={12} sm={4}>
        //         <Autocomplete
        //           options={doctorSuggestions}
        //           getOptionLabel={(option) =>
        //             `${option.name} (${option.regId})`
        //           }
        //           loading={loadingDoctors}
        //           // value={
        //           //   invoice && formData && formData.doctorId && formData.doctorId
        //           // }
        //           fullWidth
        //           onInputChange={(e, value) => setDoctorSearchInput(value)}
        //           onChange={handleSelectDoctor}
        //           renderOption={(props, option, { inputValue }) => {
        //             const nameParts = parse(
        //               option.name,
        //               match(option.name, inputValue)
        //             );
        //             const idParts = parse(
        //               option.regId,
        //               match(option.regId, inputValue)
        //             );

        //             return (
        //               <Box
        //                 component="li"
        //                 {...props}
        //                 sx={{
        //                   display: "flex",
        //                   flexDirection: "column",
        //                   alignItems: "flex-start",
        //                   justifyContent: "flex-start",
        //                   p: 1.2,
        //                   borderBottom: "1px solid #eee",
        //                   width: "100%",
        //                   "&:hover": { backgroundColor: "#f0f4f8" },
        //                 }}
        //               >
        //                 <Typography
        //                   variant="subtitle2"
        //                   fontWeight={600}
        //                   sx={{ textAlign: "left", width: "100%" }}
        //                 >
        //                   {nameParts.map((part, index) => (
        //                     <span
        //                       key={index}
        //                       style={{
        //                         fontWeight: part.highlight ? 700 : 400,
        //                         backgroundColor: part.highlight
        //                           ? "#ffe082"
        //                           : "transparent",
        //                         padding: "2px",
        //                         borderRadius: "3px",
        //                       }}
        //                     >
        //                       {part.text}
        //                     </span>
        //                   ))}
        //                 </Typography>

        //                 <Typography
        //                   variant="caption"
        //                   color="text.secondary"
        //                   sx={{ textAlign: "left", width: "100%" }}
        //                 >
        //                   ID:{" "}
        //                   {idParts.map((part, index) => (
        //                     <span
        //                       key={index}
        //                       style={{
        //                         fontWeight: part.highlight ? 600 : 400,
        //                         backgroundColor: part.highlight
        //                           ? "#ffe082"
        //                           : "transparent",
        //                       }}
        //                     >
        //                       {part.text}
        //                     </span>
        //                   ))}
        //                 </Typography>
        //               </Box>
        //             );
        //           }}
        //           renderInput={(params) => (
        //             <TextField
        //               {...params}
        //               label="Search Doctor"
        //               variant="outlined"
        //               size="small"
        //               sx={{ backgroundColor: "#fff" }}
        //               InputProps={{
        //                 ...params.InputProps,
        //                 endAdornment: (
        //                   <>
        //                     {loadingDoctors ? (
        //                       <CircularProgress color="inherit" size={20} />
        //                     ) : null}
        //                     {params.InputProps.endAdornment}
        //                   </>
        //                 ),
        //               }}
        //             />
        //           )}
        //           noOptionsText={
        //             doctorSearchInput.trim() ? (
        //               <Box>
        //                 <Typography variant="body2" sx={{ mb: 1 }}>
        //                   No doctor found.
        //                 </Typography>
        //                 {user?._doc?.permissions?.doctorManagement?.create && (
        //                   <Button
        //                     variant="contained"
        //                     size="small"
        //                     onClick={() => {
        //                       setIsDrawerOpen(true);
        //                       setPatientForm(false);
        //                       setDoctorForm(true);
        //                       setDoctorData({
        //                         ...doctorData,
        //                         name: doctorSearchInput.trim(),
        //                       });
        //                       setCenterForm(false);
        //                     }}
        //                   >
        //                     Register
        //                   </Button>
        //                 )}
        //               </Box>
        //             ) : (
        //               "Search by: Reg.Id or Name"
        //             )
        //           }
        //         />
        //       </Grid>
        //       <Grid item xs={12} sm={4}>
        //         <Autocomplete
        //           options={centerSuggestions}
        //           getOptionLabel={(option) =>
        //             `${option.centreName} (${option.centreId})`
        //           }
        //           loading={loadingCenters}
        //           // value={
        //           //   invoice && formData && formData.centerId && formData.centerId
        //           // }
        //           fullWidth
        //           onInputChange={(e, value) => setCenterSearchInput(value)}
        //           onChange={handleSelectCenter}
        //           renderOption={(props, option, { inputValue }) => {
        //             const nameParts = parse(
        //               option.centreName,
        //               match(option.centreName, inputValue)
        //             );
        //             const idParts = parse(
        //               option.centreId,
        //               match(option.centreId, inputValue)
        //             );

        //             return (
        //               <Box
        //                 component="li"
        //                 {...props}
        //                 sx={{
        //                   display: "flex",
        //                   flexDirection: "column",
        //                   alignItems: "flex-start",
        //                   justifyContent: "flex-start",
        //                   p: 1.2,
        //                   borderBottom: "1px solid #eee",
        //                   width: "100%",
        //                   "&:hover": { backgroundColor: "#f0f4f8" },
        //                 }}
        //               >
        //                 <Typography
        //                   variant="subtitle2"
        //                   fontWeight={600}
        //                   sx={{ textAlign: "left", width: "100%" }}
        //                 >
        //                   {nameParts.map((part, index) => (
        //                     <span
        //                       key={index}
        //                       style={{
        //                         fontWeight: part.highlight ? 700 : 400,
        //                         backgroundColor: part.highlight
        //                           ? "#ffe082"
        //                           : "transparent",
        //                         padding: "2px",
        //                         borderRadius: "3px",
        //                       }}
        //                     >
        //                       {part.text}
        //                     </span>
        //                   ))}
        //                 </Typography>

        //                 <Typography
        //                   variant="caption"
        //                   color="text.secondary"
        //                   sx={{ textAlign: "left", width: "100%" }}
        //                 >
        //                   ID:{" "}
        //                   {idParts.map((part, index) => (
        //                     <span
        //                       key={index}
        //                       style={{
        //                         fontWeight: part.highlight ? 600 : 400,
        //                         backgroundColor: part.highlight
        //                           ? "#ffe082"
        //                           : "transparent",
        //                       }}
        //                     >
        //                       {part.text}
        //                     </span>
        //                   ))}
        //                 </Typography>
        //               </Box>
        //             );
        //           }}
        //           renderInput={(params) => (
        //             <TextField
        //               {...params}
        //               label="Search Center"
        //               variant="outlined"
        //               size="small"
        //               sx={{ backgroundColor: "#fff" }}
        //               InputProps={{
        //                 ...params.InputProps,
        //                 endAdornment: (
        //                   <>
        //                     {loadingCenters ? (
        //                       <CircularProgress color="inherit" size={20} />
        //                     ) : null}
        //                     {params.InputProps.endAdornment}
        //                   </>
        //                 ),
        //               }}
        //             />
        //           )}
        //           noOptionsText={
        //             centerSearchInput.trim() ? (
        //               <Box>
        //                 <Typography variant="body2" sx={{ mb: 1 }}>
        //                   No center found.
        //                 </Typography>
        //                 <Button
        //                   variant="contained"
        //                   size="small"
        //                   onClick={() => {
        //                     setIsDrawerOpen(true);
        //                     setPatientForm(false);
        //                     setDoctorForm(false);
        //                     setCenterForm(true);
        //                     setCenterData({
        //                       ...centerData,
        //                       centreName: centerSearchInput.trim(),
        //                     });
        //                   }}
        //                 >
        //                   Register
        //                 </Button>
        //               </Box>
        //             ) : (
        //               "Search by: Center Id or Name"
        //             )
        //           }
        //         />
        //       </Grid>
        //     </Grid>
        //     <Grid container spacing={2}>
        //       {/* Appointment Date and Time in a Row */}
        //       <Grid item xs={12} sm={4}>
        //         <LocalizationProvider dateAdapter={AdapterDayjs}>
        //           <DatePicker
        //             label="Appointment Date"
        //             value={formData.date}
        //             onChange={handleDateChange}
        //             format="DD.MM.YYYY"
        //             minDate={dayjs()} // Disable previous dates
        //             renderInput={(params) => (
        //               <TextField {...params} size="small" fullWidth />
        //             )}
        //           />
        //         </LocalizationProvider>
        //       </Grid>

        //       <Grid item xs={12} sm={4}>
        //         {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        //           <TimePicker
        //             label="Appointment Time"
        //             value={formData.time}
        //             onChange={handleTimeChange}
        //             renderInput={(params) => (
        //               <TextField {...params} size="small" fullWidth />
        //             )}
        //           />
        //         </LocalizationProvider> */}
        //       </Grid>

        //       <Grid item xs={12} sm={4}>
        //         <TextField
        //           label="Notes"
        //           name="note"
        //           value={formData.note}
        //           onChange={handleChange}
        //           variant="outlined"
        //           fullWidth
        //         />
        //       </Grid>

        //       <Grid item xs={12}>
        //         <Button
        //           type="submit"
        //           disabled={loadingSubmit}
        //           variant="contained"
        //           color="primary"
        //         >
        //           {loadingSubmit ? "Submitting..." : "Submit"}
        //         </Button>
        //       </Grid>
        //     </Grid>
        //   </Box>
        // </Paper>
        <Accordion
          sx={{
            borderRadius: "12px",
            backgroundColor: "#1e293b", // slate-800
            "&:before": { display: "none" },
            "&.Mui-expanded": {
              margin: "16px 0",
              boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#facc15" }} />}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#facc15",
                fontWeight: 700,
                letterSpacing: 0.5,
              }}
            >
              Book Appointment
            </Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ p: 3, backgroundColor: "#fff" }}>
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                "& .MuiTextField-root": { mb: 2, width: "100%" },
                "& .MuiFormControl-root": { mb: 2, width: "100%" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container spacing={3}>
                {/* === Patient Autocomplete === */}
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    options={patientSuggestions}
                    getOptionLabel={(option) =>
                      `${option.name} (${option.patientID}) - ${option.mobile}`
                    }
                    loading={loadingPatients}
                    onInputChange={(e, value) => setPatientSearchInput(value)}
                    onChange={handleSelectPatient}
                    renderOption={(props, option, { inputValue }) => {
                      const nameParts = parse(
                        option.name,
                        match(option.name, inputValue),
                      );
                      const idParts = parse(
                        option.patientID,
                        match(option.patientID, inputValue),
                      );
                      const mobileParts = parse(
                        option.mobile,
                        match(option.mobile, inputValue),
                      );
                      const gender = option.gender;
                      const dob = option.dob;

                      return (
                        <Box
                          component="li"
                          {...props}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            p: 1.2,
                            borderBottom: "1px solid #eee",
                            width: "100%",
                            "&:hover": { backgroundColor: "#f0f4f8" },
                          }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box component="span">
                              {nameParts.map((part, index) => (
                                <span
                                  key={index}
                                  style={{
                                    fontWeight: part.highlight ? 700 : 400,
                                    backgroundColor: part.highlight
                                      ? "#ffe082"
                                      : "transparent",
                                    padding: "2px",
                                    borderRadius: "3px",
                                    fontSize: "13px",
                                  }}
                                >
                                  {part.text}
                                </span>
                              ))}
                            </Box>
                            <Box
                              component="span"
                              sx={{
                                fontWeight: 400,
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                fontSize: "10px",
                              }}
                            >
                              {gender}
                              {getGenderIcon(gender)}
                            </Box>
                          </Box>

                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ width: "100%" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                              }}
                            >
                              {/* Left side: Age and Phone */}
                              <Box component="span">
                                <span style={{ fontWeight: 400 }}>
                                  Age: {showAge(dob)}
                                </span>{" "}
                                | Ph:{" "}
                                {mobileParts.map((part, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      fontWeight: part.highlight ? 600 : 400,
                                      backgroundColor: part.highlight
                                        ? "#ffe082"
                                        : "transparent",
                                    }}
                                  >
                                    {part.text}
                                  </span>
                                ))}
                              </Box>

                              {/* Right side: ID */}
                              <Box component="span">
                                {idParts.map((part, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      fontSize: "10px",
                                      fontWeight: part.highlight ? 600 : 400,
                                      backgroundColor: part.highlight
                                        ? "#ffe082"
                                        : "transparent",
                                    }}
                                  >
                                    {part.text}
                                  </span>
                                ))}
                              </Box>
                            </Box>
                          </Typography>
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Patient"
                        variant="outlined"
                        size="small"
                        sx={{ backgroundColor: "#fff" }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingPatients ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    noOptionsText={
                      patientSearchInput.trim() ? (
                        <Box>
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            No patient found.
                          </Typography>
                          {user?._doc?.permissions?.patientManagement
                            ?.create && (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => {
                                setIsDrawerOpen(true);
                                setPatientForm(true);
                                setPatientData({
                                  ...patientData,
                                  name: patientSearchInput.trim(),
                                });
                                setDoctorForm(false);
                                setCenterForm(false);
                              }}
                            >
                              Register
                            </Button>
                          )}
                        </Box>
                      ) : (
                        "Search by: Id, Name or Ph.No"
                      )
                    }
                  />
                </Grid>

                {/* === Doctor Autocomplete === */}
                <Grid item xs={12} sm={4}>
                  {/* your Autocomplete for doctor */}
                  <Autocomplete
                    options={doctorSuggestions}
                    getOptionLabel={(option) =>
                      `${option.name} (${option.regId})`
                    }
                    loading={loadingDoctors}
                    // value={
                    //   invoice && formData && formData.doctorId && formData.doctorId
                    // }
                    fullWidth
                    onInputChange={(e, value) => setDoctorSearchInput(value)}
                    onChange={handleSelectDoctor}
                    renderOption={(props, option, { inputValue }) => {
                      const nameParts = parse(
                        option.name,
                        match(option.name, inputValue),
                      );
                      const idParts = parse(
                        option.regId,
                        match(option.regId, inputValue),
                      );

                      return (
                        <Box
                          component="li"
                          {...props}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            p: 1.2,
                            borderBottom: "1px solid #eee",
                            width: "100%",
                            "&:hover": { backgroundColor: "#f0f4f8" },
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            sx={{ textAlign: "left", width: "100%" }}
                          >
                            {nameParts.map((part, index) => (
                              <span
                                key={index}
                                style={{
                                  fontWeight: part.highlight ? 700 : 400,
                                  backgroundColor: part.highlight
                                    ? "#ffe082"
                                    : "transparent",
                                  padding: "2px",
                                  borderRadius: "3px",
                                }}
                              >
                                {part.text}
                              </span>
                            ))}
                          </Typography>

                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ textAlign: "left", width: "100%" }}
                          >
                            ID:{" "}
                            {idParts.map((part, index) => (
                              <span
                                key={index}
                                style={{
                                  fontWeight: part.highlight ? 600 : 400,
                                  backgroundColor: part.highlight
                                    ? "#ffe082"
                                    : "transparent",
                                }}
                              >
                                {part.text}
                              </span>
                            ))}
                          </Typography>
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Doctor"
                        variant="outlined"
                        size="small"
                        sx={{ backgroundColor: "#fff" }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingDoctors ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    noOptionsText={
                      doctorSearchInput.trim() ? (
                        <Box>
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            No doctor found.
                          </Typography>
                          {user?._doc?.permissions?.doctorManagement
                            ?.create && (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => {
                                setIsDrawerOpen(true);
                                setPatientForm(false);
                                setDoctorForm(true);
                                setDoctorData({
                                  ...doctorData,
                                  name: doctorSearchInput.trim(),
                                });
                                setCenterForm(false);
                              }}
                            >
                              Register
                            </Button>
                          )}
                        </Box>
                      ) : (
                        "Search by: Reg.Id or Name"
                      )
                    }
                  />
                </Grid>

                {/* === Center Autocomplete === */}
                <Grid item xs={12} sm={4}>
                  {/* your Autocomplete for center */}
                  <Autocomplete
                    options={centerSuggestions}
                    getOptionLabel={(option) =>
                      `${option.centreName} (${option.centreId})`
                    }
                    loading={loadingCenters}
                    // value={
                    //   invoice && formData && formData.centerId && formData.centerId
                    // }
                    fullWidth
                    onInputChange={(e, value) => setCenterSearchInput(value)}
                    onChange={handleSelectCenter}
                    renderOption={(props, option, { inputValue }) => {
                      const nameParts = parse(
                        option.centreName,
                        match(option.centreName, inputValue),
                      );
                      const idParts = parse(
                        option.centreId,
                        match(option.centreId, inputValue),
                      );

                      return (
                        <Box
                          component="li"
                          {...props}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            p: 1.2,
                            borderBottom: "1px solid #eee",
                            width: "100%",
                            "&:hover": { backgroundColor: "#f0f4f8" },
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            sx={{ textAlign: "left", width: "100%" }}
                          >
                            {nameParts.map((part, index) => (
                              <span
                                key={index}
                                style={{
                                  fontWeight: part.highlight ? 700 : 400,
                                  backgroundColor: part.highlight
                                    ? "#ffe082"
                                    : "transparent",
                                  padding: "2px",
                                  borderRadius: "3px",
                                }}
                              >
                                {part.text}
                              </span>
                            ))}
                          </Typography>

                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ textAlign: "left", width: "100%" }}
                          >
                            ID:{" "}
                            {idParts.map((part, index) => (
                              <span
                                key={index}
                                style={{
                                  fontWeight: part.highlight ? 600 : 400,
                                  backgroundColor: part.highlight
                                    ? "#ffe082"
                                    : "transparent",
                                }}
                              >
                                {part.text}
                              </span>
                            ))}
                          </Typography>
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Center"
                        variant="outlined"
                        size="small"
                        sx={{ backgroundColor: "#fff" }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingCenters ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    noOptionsText={
                      centerSearchInput.trim() ? (
                        <Box>
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            No center found.
                          </Typography>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setIsDrawerOpen(true);
                              setPatientForm(false);
                              setDoctorForm(false);
                              setCenterForm(true);
                              setCenterData({
                                ...centerData,
                                centreName: centerSearchInput.trim(),
                              });
                            }}
                          >
                            Register
                          </Button>
                        </Box>
                      ) : (
                        "Search by: Center Id or Name"
                      )
                    }
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Appointment Date"
                      value={formData.date}
                      onChange={handleDateChange}
                      format="DD.MM.YYYY"
                      minDate={dayjs()}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Notes"
                    name="note"
                    value={formData.note}
                    onChange={handleChange}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={4}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    paddingBottom: "17px",
                    paddingLeft: "23px",
                  }}
                >
                  <Button
                    type="submit"
                    disabled={loadingSubmit}
                    variant="contained"
                    color="warning"
                    fullWidth
                  >
                    {loadingSubmit ? "Booking..." : "Book"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {/* <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            width: { xs: "95vw", sm: "40vw" },
            height: "100vh",
            overflow: "hidden",
          },
        }}
      > */}
      <Dialog
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
        maxWidth="xs"
        fullWidth
      >
        {patientForm && (
          <Box
            component="form"
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                background: "#1F2937",
                color: "#FACC14",
                p: 1,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                🧑🏻 Register Patient
              </Typography>
              <Button
                variant="contained"
                onClick={handleCloseDrawer}
                size="small"
                color="error"
              >
                Close
              </Button>
            </Box>

            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                p: 2,
              }}
            >
              <Grid container spacing={3}>
                {/* Full Name */}
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Full Name"
                    variant="outlined"
                    name="name"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.name}
                    helperText={errorsPatient.name}
                    value={patientData.name}
                  />
                </Grid>

                {/* DOB + Age */}
                <Grid item xs={12} sm={12}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControl
                      sx={{ flex: 2, mr: 1 }}
                      error={!!errorsPatient.dob}
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Date of Birth"
                          onChange={handleDateChangePatient}
                          format="DD-MM-YY"
                          maxDate={dayjs()}
                          value={
                            patientData.dob
                              ? dayjs(patientData.dob, "DD-MM-YY")
                              : null
                          }
                        />
                      </LocalizationProvider>
                    </FormControl>

                    <Typography
                      sx={{
                        mx: 1,
                        background: "#1F2937",
                        color: "#FACC14",
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "8px",
                        fontWeight: 600,
                      }}
                    >
                      OR
                    </Typography>

                    <TextField
                      label="Age"
                      variant="outlined"
                      type="number"
                      name="age"
                      sx={{ flex: 1 }}
                      onChange={handleChangePatient}
                      value={patientData.age}
                    />
                  </Box>
                </Grid>

                {/* Gender */}
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth error={!!errorsPatient.gender}>
                    <Select
                      value={patientData.gender || ""}
                      onChange={handleGenderChange}
                      name="gender"
                      displayEmpty
                      variant="outlined"
                    >
                      <MenuItem value="" disabled>
                        Select Gender
                      </MenuItem>
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                      <MenuItem value="Others">Others</MenuItem>
                    </Select>
                    <FormHelperText>{errorsPatient.gender}</FormHelperText>
                  </FormControl>
                </Grid>

                {/* Mobile */}
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Mobile (Optional)"
                    variant="outlined"
                    type="tel"
                    name="mobile"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.mobile}
                    helperText={errorsPatient.mobile}
                    value={patientData.mobile}
                  />
                </Grid>

                {/* Address */}
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Address (Optional)"
                    variant="outlined"
                    name="address"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.address}
                    helperText={errorsPatient.address}
                    value={patientData.address}
                  />
                </Grid>

                {/* Aadhar */}
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Aadhar (Optional)"
                    variant="outlined"
                    name="aadhar"
                    onChange={handleChangePatient}
                    error={!!errorsPatient.aadhar}
                    helperText={errorsPatient.aadhar}
                    value={patientData.aadhar}
                  />
                </Grid>
              </Grid>

              <Button
                variant="contained"
                fullWidth
                onClick={handleSubmitPatient} // change as needed
                disabled={patientLoading}
                sx={{
                  backgroundColor: "#ff8c00",
                  color: "#000000",
                  fontWeight: 700,
                  mt: 3,
                  fontSize: "1.05rem",
                  textTransform: "uppercase",
                  padding: "12px 36px",
                  borderRadius: "0px",
                  boxShadow: "0px 3px 8px rgba(0,0,0,0.2)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#ff7000",
                    boxShadow: "0px 5px 14px rgba(0,0,0,0.3)",
                  },
                }}
              >
                {patientLoading ? "Submitting..." : "Submit"}
              </Button>
            </Box>

            {/* Submit Button - Always Visible */}

            {/* <Button
              variant="contained"
              onClick={handleSubmitPatient}
              disabled={patientLoading}
              sx={{
                backgroundColor: "#ff8c00",
                color: "#000000",
                fontWeight: 700,
                fontSize: "1.1rem",
                textTransform: "uppercase",
                padding: "12px 36px",
                borderRadius: "0px",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#ff7000",
                  boxShadow: "0px 6px 14px rgba(0,0,0,0.4)",
                },
              }}
            >
              {patientLoading ? "Submitting..." : "Submit"}
            </Button> */}
          </Box>
        )}
        {doctorForm && (
          <Box
            component="form"
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header Section */}
            <Box
              sx={{
                background: "#1F2937",
                color: "#FACC14",
                p: 1,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                👨‍⚕️ Register Doctor
              </Typography>
              <Button
                variant="contained"
                onClick={handleCloseDrawer}
                size="small"
                color="error"
              >
                Close
              </Button>
            </Box>

            {/* Scrollable Content */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                p: 2,
              }}
            >
              <Grid container spacing={3}>
                {/* Doctor Info */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Doctor Name"
                    variant="outlined"
                    name="name"
                    size="small"
                    onChange={handleNewChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    value={doctorData.name}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Registration ID"
                    variant="outlined"
                    name="regId"
                    size="small"
                    onChange={handleNewChange}
                    error={!!errors.regId}
                    helperText={errors.regId}
                    value={doctorData.regId}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Note"
                    variant="outlined"
                    name="note"
                    size="small"
                    onChange={handleNewChange}
                    error={!!errors.note}
                    helperText={errors.note}
                    value={doctorData.note}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Consultation Fees"
                    variant="outlined"
                    type="number"
                    name="consultFees"
                    size="small"
                    onChange={handleNewChange}
                    error={!!errors.consultFees}
                    helperText={errors.consultFees}
                    value={doctorData.consultFees}
                  />
                </Grid>

                {/* Dropdowns */}
                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Is Consultant?</InputLabel>
                    <Select
                      value={doctorData.isConsultant}
                      name="isConsultant"
                      size="small"
                      onChange={handleNewChange}
                      label="Is Consultant?"
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Is Signatory?</InputLabel>
                    <Select
                      name="isSignatory"
                      size="small"
                      value={doctorData.isSignatory}
                      onChange={handleNewChange}
                      label="Is Signatory?"
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Signatory Category</InputLabel>
                    <Select
                      name="signatoryCat"
                      size="small"
                      value={doctorData.signatoryCat}
                      onChange={handleNewChange}
                      label="Signatory Category"
                    >
                      <MenuItem value="Pathology">Pathology</MenuItem>
                      <MenuItem value="Radiology">Radiology</MenuItem>
                      <MenuItem value="Microbiology">Microbiology</MenuItem>
                      <MenuItem value="Biochemistry">Biochemistry</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Sign Header + Upload */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Sign Header"
                    variant="outlined"
                    fullWidth
                    multiline
                    name="signHeader"
                    value={doctorData.signHeader}
                    onChange={handleNewChange}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <Typography
                      sx={{
                        position: "absolute",
                        fontSize: "14px",
                        padding: "5px",
                      }}
                    >
                      Signature
                    </Typography>
                    <TextField
                      type="file"
                      variant="outlined"
                      name="signwebLink"
                      onChange={handleSignFileChange}
                      inputProps={{ accept: "image/*" }}
                    />
                  </FormControl>
                </Grid>

                {/* Qualifications */}
                <Grid item xs={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 4,
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #f9fafb, #eef2f3)",
                      boxShadow:
                        "0 8px 20px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.4)",
                      backdropFilter: "blur(12px)",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={600}
                      gutterBottom
                      sx={{
                        color: "#1e293b",
                        borderBottom: "2px solid #cbd5e1",
                        display: "inline-block",
                        pb: 1,
                        mb: 3,
                      }}
                    >
                      🎓 Qualifications & Experience
                    </Typography>

                    <Grid container spacing={2}>
                      {doctorData.qualifications.map((qualification, index) => (
                        <Fade in={true} timeout={800} key={index}>
                          <Grid
                            item
                            xs={12} // Full width on small screens
                            sm={6} // 2 per row on medium+ screens
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              mb: 1,
                            }}
                          >
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              label={`Qualification ${index + 1}`}
                              value={qualification}
                              onChange={(e) =>
                                handleQualificationChange(index, e.target.value)
                              }
                              error={!!errors.qualifications}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "12px",
                                  backgroundColor: "#fff",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                  },
                                },
                              }}
                            />
                            <Tooltip title="Remove" arrow>
                              <span>
                                <IconButton
                                  onClick={() => removeQualification(index)}
                                  disabled={
                                    doctorData.qualifications.length === 1
                                  }
                                  sx={{
                                    backgroundColor: "#fee2e2",
                                    color: "#dc2626",
                                    "&:hover": {
                                      backgroundColor: "#fca5a5",
                                    },
                                    "&.Mui-disabled": {
                                      opacity: 0.4,
                                    },
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Grid>
                        </Fade>
                      ))}
                    </Grid>

                    <Box
                      sx={{
                        mt: 3,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Tooltip title="Add Qualification" arrow>
                        <span>
                          <IconButton
                            onClick={addQualification}
                            disabled={doctorData.qualifications.length >= 6}
                            sx={{
                              backgroundColor:
                                doctorData.qualifications.length >= 6
                                  ? "#d1d5db"
                                  : "#16a34a",
                              color: "white",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                backgroundColor:
                                  doctorData.qualifications.length >= 6
                                    ? "#d1d5db"
                                    : "#15803d",
                                transform: "scale(1.08)",
                              },
                              "&.Mui-disabled": {
                                opacity: 0.4,
                              },
                            }}
                          >
                            <AddIcon />
                          </IconButton>
                        </span>
                      </Tooltip>

                      <Typography
                        variant="body2"
                        sx={{ color: "#64748b", fontStyle: "italic" }}
                      >
                        You can add up to 6 qualifications.
                      </Typography>
                    </Box>

                    {errors.qualifications && (
                      <Typography
                        color="error"
                        sx={{
                          mt: 2,
                          fontSize: "0.9rem",
                          fontWeight: 500,
                        }}
                      >
                        ⚠️ {errors.qualifications}
                      </Typography>
                    )}
                  </Paper>
                </Grid>
              </Grid>
              <Button
                variant="contained"
                fullWidth
                onClick={handleDoctorSubmit} // change as needed
                disabled={doctorLoading}
                sx={{
                  backgroundColor: "#ff8c00",
                  color: "#000000",
                  fontWeight: 700,
                  mt: 3,
                  fontSize: "1.05rem",
                  textTransform: "uppercase",
                  padding: "12px 36px",
                  borderRadius: "0px",
                  boxShadow: "0px 3px 8px rgba(0,0,0,0.2)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#ff7000",
                    boxShadow: "0px 5px 14px rgba(0,0,0,0.3)",
                  },
                }}
              >
                {doctorLoading ? "Submitting..." : "Submit"}
              </Button>
            </Box>

            {/* Submit Button - Always Visible */}

            {/* <Button
              variant="contained"
              onClick={handleDoctorSubmit}
              disabled={doctorLoading}
              sx={{
                backgroundColor: "#ff8c00",
                color: "#000000",
                fontWeight: 700,
                fontSize: "1.1rem",
                textTransform: "uppercase",
                padding: "12px 36px",
                borderRadius: "0px",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#ff7000",
                  boxShadow: "0px 6px 14px rgba(0,0,0,0.4)",
                },
              }}
            >
              {doctorLoading ? "Submitting..." : "Submit"}
            </Button> */}
          </Box>
        )}

        {centerForm && (
          <Box
            component="form"
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "#1F2937",
                color: "#FACC14",
                p: 1,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                🏢 Register Centre
              </Typography>
              <Button
                variant="contained"
                onClick={handleCloseDrawer}
                size="small"
                color="error"
              >
                Close
              </Button>
            </Box>

            {/* Form Body */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                p: 2,
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Center Name"
                    variant="outlined"
                    name="centreName"
                    onChange={handleChangeCenter}
                    value={centerData.centreName}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Centre Address"
                    variant="outlined"
                    name="centreAddress"
                    onChange={handleChangeCenter}
                    value={centerData.centreAddress}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Centre Contact Person"
                    variant="outlined"
                    name="centreContactPerson"
                    onChange={handleChangeCenter}
                    value={centerData.centreContactPerson}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label="Centre Contact Number"
                    variant="outlined"
                    name="centreContactNumber"
                    onChange={handleChangeCenter}
                    value={centerData.centreContactNumber}
                  />
                </Grid>
              </Grid>
              <Button
                variant="contained"
                fullWidth
                onClick={handleSelectCenter} // change as needed
                disabled={centerLoading}
                sx={{
                  backgroundColor: "#ff8c00",
                  color: "#000000",
                  fontWeight: 700,
                  mt: 3,
                  fontSize: "1.05rem",
                  textTransform: "uppercase",
                  padding: "12px 36px",
                  borderRadius: "0px",
                  boxShadow: "0px 3px 8px rgba(0,0,0,0.2)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#ff7000",
                    boxShadow: "0px 5px 14px rgba(0,0,0,0.3)",
                  },
                }}
              >
                {centerLoading ? "Submitting..." : "Submit"}
              </Button>
            </Box>

            {/* Submit Button - Always Visible */}

            {/* Submit Button Fixed at Bottom */}
            {/* <Button
              variant="contained"
              onClick={handleSubmitCenter}
              disabled={centerLoading}
              sx={{
                backgroundColor: "#ff8c00",
                color: "#000000",
                fontWeight: 700,
                fontSize: "1.1rem",
                textTransform: "uppercase",
                padding: "12px 36px",
                borderRadius: "0px",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#ff7000",
                  boxShadow: "0px 6px 14px rgba(0,0,0,0.4)",
                },
              }}
            >
              {centerLoading ? "Submitting..." : "Submit"}
            </Button> */}
          </Box>
        )}
      </Dialog>
      {/* </Drawer> */}
      <AppointmentList
        appointments={appointments}
        setAppointments={setAppointments}
      />
    </>
  );
};

export default DoctorConsult;
